import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles(() => ({
    backgroundPar: {
        background: 'rgba(31, 156, 228, 0.04)',
        borderRadius: 8
    }
}));
